import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  //   typography: {
  //     fontFamily: `'DM Sans', sans-serif`, // Set DM Sans as the default font
  //   },
  palette: {
    // Define your theme colors here if necessary
    primary: {
      main: "#CFFF04", // Example color
    },
    // mode: 'dark',
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          scrollbarColor: "#555 #1e1e1e", // Firefox

          scrollbarWidth: "thin", // Firefox

          "&::-webkit-scrollbar": {
            width: "8px",
          },

          "&::-webkit-scrollbar-track": {
            background: "#1e1e1e",
          },

          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#555",

            borderRadius: "4px",

            border: "2px solid #1e1e1e",
          },

          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: "#888",
          },
        },
      },
    },
  },
});

export default theme;
